<template>
  <ion-page>
    <ion-content class="ion-padding-top bg-grad-content">
      <ion-slides
        v-if="carouselImage.length > 0"
        pager="false"
        :options="slideOpts"
        ref="homeslide"
        class="ion-slides-home"
        @click="sliderClicked($event)"
      >
        <ion-slide
          v-for="(s, index) in carouselImage"
          :key="index"
          style="border-radius: 10px;"
        >
          <img v-lazy="s.image" style="border-radius: 10px;" />
        </ion-slide>
      </ion-slides>
      <ion-list class="home-menu-list">
        <ion-item
          v-for="(mcItem, indexmc) in mcMotoCollection"
          :key="indexmc"
          @click="showMdmoto(mcItem)"
        >
          <ion-thumbnail slot="start">
            <img class="" src="/img/icons/android-chrome-192x192.png" />
          </ion-thumbnail>
          <ion-label>{{ mcItem.descripcion }}</ion-label>
        </ion-item>
      </ion-list>
      <div
        class="cupertino-pane"
        style="display: none"
        id="cupertino-pane-home"
      >
        <div
          v-if="carouselImageItem"
          class="picture"
          :style="`background-image: url('${carouselImageItem.image}');`"
        ></div>
        <div v-if="carouselImageItem" class="content">
          <div class="info">
            <div class="left-side">
              <h1>Lion Accesorios</h1>
              <p>
                Contactenos para poder asesorarlo mejor.
              </p>
            </div>
            <div class="right-side">
              <ion-row>
                <ion-col col-6>
                  <ion-icon
                    name="expand"
                    size="large"
                    @click="zoomImage"
                  ></ion-icon>
                </ion-col>

                <ion-col v-if="carouselImageItem.external_link != ''" col-6>
                  <a :href="carouselImageItem.external_link" target="_blank"
                    ><ion-icon name="link" size="large"></ion-icon
                  ></a>
                </ion-col>
              </ion-row>
              <ion-button @click="$router.push({ name: 'contact' })"
                >Contactenos</ion-button
              >
            </div>
          </div>
          <div class="description">
            <div class="powered">
              <div class="icon">
                <img
                  src="/img/icons/android-chrome-192x192.png"
                  alt="nike-app"
                />
              </div>
              <div class="title">
                <div class="by">
                  Powered by
                </div>
                <div class="name">
                  Lion
                  <!-- <div class="age">4+</div> -->
                </div>
              </div>
            </div>
            <div
              v-if="carouselImageItem.internal_link.length > 0"
              class="store"
              @click="$router.push(carouselImageItem.internal_link)"
            >
              Ver más
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { CupertinoPane } from 'cupertino-pane'
import { actionSheetController } from '@ionic/vue'
import effect from '@/tools/slide_effect'
export default {
  components: {},
  data(vm) {
    return {
      mcMotoCollection: [],
      picture: '/img/icons/android-chrome-512x512.png',
      myPane: null,
      paneReBuild: true,
      settingsPane: {
        initialBreak: 'top',
        breaks: {
          top: { enabled: true, height: 450 },
          middle: { enabled: false },
          bottom: { enabled: false }
        },
        backdrop: true,
        backdropOpacity: 0.4,
        topperOverflow: false,
        bottomClose: true,
        buttonClose: true,
        showDraggable: false,
        bottomOffset: 8,
        onBackdropTap: () => vm.destroyDrawer()
      },
      options: {},
      openModal: false,
      openAS: false,
      slideOpts: effect.coverflowEffect,
      carouselImage: [],
      carouselImageItem: null
    }
  },
  ionViewDidEnter() {
    this.$store.dispatch('app/keepPageState', false)
  },
  ionViewDidLeave() {},
  ionViewWillEnter() {
    if (!this.$store.getters['app/keepPageState']) {
      this.mcMotoCollection = []
      this.carouselImage = []
      this.$emitter.emit('full-loader', { open: true })
      this.getIndexData()
    }
  },
  ionViewWillLeave() {
    if (this.myPane && this.myPane.isPanePresented())
      this.myPane.destroy({ animate: true })
  },
  created() {},
  beforeUnmount() {},
  mounted() {
    window.addEventListener('orientationchange', (event) => {
      if (this.myPane && this.myPane.isPanePresented())
        this.myPane.destroy({ animate: true })
      this.paneReBuild = true
    })
  },
  computed: {},
  methods: {
    async showMdmoto(item) {
      let buttons = []
      item.modelomoto.data.forEach((el) => {
        let itemMcMoto = {
          text: el.descripcion,
          handler: () => {
            this.$router.push({
              name: 'product-list',
              params: {
                motobrand: item.descripcion_hide,
                motomodel: el.descripcion_hide,
                motomodel_id: el.id
              }
            })
          }
        }
        buttons.push(itemMcMoto)
      })
      buttons.push({
        text: 'Cancelar',
        role: 'cancel',
        handler: () => {}
      })

      const actionSheet = await actionSheetController.create({
        header: 'Seleccione un modelo',
        cssClass: 'mdmoto-asheet',
        buttons: buttons
      })
      return actionSheet.present()
    },
    getIndexData() {
      this.$http
        .get('app-mobile/index')
        .then((res) => {
          this.mcMotoCollection = res.data.mcMotoCollection.data
          this.carouselImage = res.data.carouselImageCollection.data
          this.$emitter.emit('full-loader', { open: false })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async zoomImage() {
      this.$store.dispatch('app/keepPageState', true)
      this.$store.dispatch('app/imageToView', this.picture)
      this.$router.push({ name: 'view-image' })
    },
    async destroyDrawer() {
      this.myPane.destroy({ animate: true })
    },
    sliderClicked(event) {
      if (this.$store.state.app.orientation === 'landscape') {
        this.$emitter.emit('toast', {
          message: 'Gire su dispositivo para una mejor experiencia',
          color: 'warning'
        })
        return false
      }
      if (this.paneReBuild) {
        this.myPane = null
        this.myPane = new CupertinoPane(
          '#cupertino-pane-home',
          this.settingsPane
        )
        this.paneReBuild = false
      }
      let swiper = this.$refs.homeslide.$el.swiper
      if (
        !event.target.classList.contains('swiper-pagination-bullet') &&
        !event.target.classList.contains('swiper-button-next') &&
        !event.target.classList.contains('swiper-button-prev')
      ) {
        let image = this.carouselImage[swiper.realIndex].image
        this.carouselImageItem = this.carouselImage[swiper.realIndex]
        if (this.carouselImageItem) this.openPane(image)
      }
    },
    openPane(image) {
      this.picture = image
      this.myPane.present({ animate: true })
    }
  }
}
</script>

<style>
.mdmoto-asheet {
  --max-height: 50vh;
  --color: #777474;
}
.home-menu-list ion-item {
  --background: transparent;
  --border-color: transparent;
}

.home-menu-list {
  background: transparent;
}

.ion-slides-home {
  height: 300px;
}
.swiper-slide-shadow-right {
  opacity: 0;
}

.swiper-zoom-container {
  background-color: transparent;
}
.slide-text {
  position: absolute;
  color: white;
  bottom: 30px;
}

.swiper-pagination-bullet {
  opacity: 1;
}
.swiper-pagination-bullet-active {
  opacity: 1;
  background: var(--lion-rojo);
}

.pane {
  border-radius: 30px !important;
  width: calc(100% - 16px) !important;
  margin: auto;
  left: 0;
  right: 0;
  height: auto !important;
  background: rgba(53, 51, 51, 0.89) !important;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  padding-top: 0px !important;
}

.pane .close-button {
  background: rgb(255, 0, 34, 0.5) !important;
}

.cupertino-pane {
  display: block;
  margin: 0;
  text-align: center;
  background: transparent;
}

.cupertino-pane a {
  color: var(--ion-text-color, #000);
}

.cupertino-pane .picture {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
  border-radius: 30px 30px 0px 0px;
}

.cupertino-pane .content {
  height: 170px;
}

.cupertino-pane .content .info {
  display: flex;
  align-items: center;
  height: 100px;
  justify-content: space-between;
}

.cupertino-pane .content h1 {
  margin-top: 0px;
  font-size: 20px;
  margin-bottom: 0px;
  text-align: left;
}

.cupertino-pane .content p {
  font-size: 13px;
  margin: 0;
  margin-top: 5px;
  line-height: 18px;
}

.cupertino-pane .content .left-side {
  text-align: left;
  margin-left: 20px;
  color: #fff;
}

.cupertino-pane .content .right-side {
  margin-right: 20px;
  color: #fff;
}

.cupertino-pane .description {
  height: 70px;
  border-top: 1px solid #bdbdbd;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cupertino-pane .description .powered {
  display: flex;
  align-items: center;
}

.cupertino-pane .description .title {
  text-align: left;
}

.description .powered .icon {
  margin-right: 10px;
}

.description .powered .icon img {
  width: 28px;
  border-radius: 8px;
  display: block;
}

.description .powered .by {
  font-size: 12px;
  color: #6b6b6b;
}

.description .powered .name {
  position: relative;
  font-size: 13px;
}

.description .powered .name .age {
  position: absolute;
  right: -23px;
  bottom: 0px;
  font-size: 8px;
  color: #6b6b6b;
  border: 1px solid #6b6b6b;
  border-radius: 3px;
  padding: 1px 2px;
}

.cupertino-pane .description .store {
  font-size: 12px;
  display: flex;
  color: #6b6b6b;
  align-items: center;
  justify-content: space-between;
  width: 70px;
}

.cupertino-pane ion-button {
  font-size: 12px;
  --border-radius: 40px;
  --background: #000;
}
</style>
